const IconStopover = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.5083 3.01012L9.69167 3.06012L8.9 3.08512L8.21667 3.11012L7.51667 3.12678L6.83333 1.80178C6.73333 1.60178 6.74167 1.35178 6.875 1.16845C7 0.976784 7.21667 0.868451 7.45 0.893451L9.11667 1.04345C9.25 1.06012 9.38333 1.11012 9.48333 1.20178L11.5083 3.01012Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.525 8.36845H16.5167L12.925 8.47678L8.3 11.8851C8.19167 11.9601 8.05833 12.0018 7.925 12.0018H5.775C5.54167 12.0018 5.325 11.8685 5.21667 11.6518C5.10833 11.4434 5.13333 11.1851 5.275 11.0018L7.35833 8.22678L4.51667 7.86845C4.31667 7.84345 4.13333 7.71845 4.04167 7.54345L2.275 4.26012C2.16667 4.06012 2.175 3.82678 2.29167 3.63512C2.40833 3.44345 2.61667 3.32678 2.83333 3.33512L4.69167 3.37678C4.86667 3.37678 5.03333 3.46012 5.15 3.59345L5.88333 4.42678L7.05833 4.39345L8.15833 4.36012L8.85 4.34345L9.54167 4.31845L11.05 4.27678L11.9583 4.24345L13.7583 4.19345L14.25 4.17678H14.275C15.1167 4.21845 16.025 4.61012 16.5917 5.14345H16.6L17.4333 5.99345C18.2833 6.86012 17.7083 8.29345 16.525 8.36845Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 14.5268C8.73333 14.5268 7.70833 15.5518 7.70833 16.8184C7.70833 18.0851 8.73333 19.1101 10 19.1101C11.2667 19.1101 12.2917 18.0851 12.2917 16.8184C12.2917 15.5518 11.2583 14.5268 10 14.5268ZM10 17.8601C9.425 17.8601 8.95833 17.3934 8.95833 16.8184C8.95833 16.2435 9.425 15.7768 10 15.7768C10.575 15.7768 11.0417 16.2435 11.0417 16.8184C11.0417 17.3934 10.575 17.8601 10 17.8601Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.25 16.1934H4.75C4.4 16.1934 4.125 16.4768 4.125 16.8184C4.125 17.1601 4.4 17.4434 4.75 17.4434H6.25C6.59167 17.4434 6.875 17.1684 6.875 16.8184C6.875 16.4684 6.59167 16.1934 6.25 16.1934ZM2.75 16.1934H1.25C0.9 16.1934 0.625 16.4768 0.625 16.8184C0.625 17.1601 0.9 17.4434 1.25 17.4434H2.75C3.09167 17.4434 3.375 17.1684 3.375 16.8184C3.375 16.4684 3.09167 16.1934 2.75 16.1934Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.75 16.1934H17.25C16.9 16.1934 16.625 16.4768 16.625 16.8184C16.625 17.1601 16.9 17.4434 17.25 17.4434H18.75C19.0917 17.4434 19.375 17.1684 19.375 16.8184C19.375 16.4684 19.0917 16.1934 18.75 16.1934ZM15.25 16.1934H13.75C13.4 16.1934 13.125 16.4768 13.125 16.8184C13.125 17.1601 13.4 17.4434 13.75 17.4434H15.25C15.5917 17.4434 15.875 17.1684 15.875 16.8184C15.875 16.4684 15.5917 16.1934 15.25 16.1934Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconStopover;
